import React, { forwardRef } from 'react';
import type { ReactRefT, TRect, TSize } from '@src/types/misc';
import useBoundingClientRect from '@src/hooks/useBoundingClientRect';

type TProps = {
  anchorRect: TRect;
  anchorRef: ReactRefT<HTMLElement>;
  children: React.ReactElement<React.ComponentProps<any>, any>;
  size: TSize;
  zIndex: number;
};

const ControlPanelFrame = forwardRef(function ControlPanelFrame(
  props: TProps,
  ref: ReactRefT<HTMLDivElement>
) {
  const elRect = useBoundingClientRect(props.anchorRef?.current);
  const optimalLeft =
    props.anchorRect.x - (props.size.width - props.anchorRect.width) / 2;
  const minLeft =
    -(elRect?.x || 0) + (props.anchorRef?.current?.offsetLeft || 0);
  const browserWidth = document?.documentElement?.clientWidth || 0;
  const maxLeft = minLeft + browserWidth - props.size.width;
  const left = Math.max(minLeft, Math.min(maxLeft, optimalLeft));

  return (
    <div
      className="wysiwyg-editor-image-control-panel"
      style={{
        background: 'rgb(251, 253, 254)',
        borderRadius: 5,
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px -2px 9px',
        height: props.size.height,
        left,
        maxWidth: browserWidth,
        overflow: 'hidden',
        overflowX: browserWidth < props.size.width ? 'auto' : 'hidden',
        position: 'absolute',
        top: props.anchorRect.y - props.size.height - 6,
        width: props.size.width,
        zIndex: props.zIndex
      }}
      ref={ref}
    >
      <div style={{ height: '100%', width: props.size.width }}>
        {props.children}
      </div>
    </div>
  );
});

export default ControlPanelFrame;
